import { RelatedTableConfig } from '../../config/model/relationship-config.model';
import {Workspace} from "../../shared/enum/workspace.enum";

export class ArbeitsBereichLyrs {
  esriLayer: __esri.FeatureLayer;
}

export class DetailViewFeatureParams {
  currentArbeitsBereichLyrs?: ArbeitsBereichLyrs[];
  displayFieldname?: string;
  feature: __esri.Graphic;
  layerId: number;
  layerName?: string;
  createMode?: boolean;
  layerInfos?: any;
  featureLayerUrl?: string;
  relatedTableConfigs?: RelatedTableConfig[];
  relatedFields?: any;
  workspace?: Workspace;
  fkIdentifyLayer?: string;
  editableLayers?: any;
  changedWorkspace?: boolean;
  mapServerId?: string;
}

export class RelatedFeatureParams {
  feature: __esri.Graphic;
  createMode: boolean;
  relatedTableConfig?: any;
  relatedFields?: any;
  relatedLayerUrl?: string;
  relationshipInfo?: any;
}
